// extracted by mini-css-extract-plugin
export default {"columns":"style__columns___1xpfv","extension":"style__extension___3fbiC","indented":"style__indented___2UaoD","indentedExtension":"style__indentedExtension___3T8uW"};